"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, type ReactNode } from "react";
import { imageUrl } from "@/lib/image-url";
import { RichDescriptionSimple } from "@/app/components/RichDescription";
interface Props {
  children: ReactNode;
  /** Body text; `[energy:2]` / `[star:1]` icon tokens render inline. */
  content: string | null | undefined;
  /** Bold heading shown above the body (defaults to no heading). */
  title?: string;
  /** Optional entity art (relic/potion/card), shown to the left of the text. */
  image?: string | null;
  className?: string;
}

/**
 * Lightweight hover tooltip for inline links, shows a small popover
 * above the trigger on mouse-enter. Pointer-events-none so the popover
 * never traps clicks meant for the underlying link. Mobile users tap
 * straight through to the linked page. When `image` is given it sits to
 * the left of the text, and the body renders rich (icon tokens included)
 * rather than stripped.
 */
export default function HoverTooltip(t0) {
  const $ = _c(16);
  const {
    children,
    content,
    title,
    image,
    className
  } = t0;
  const [show, setShow] = useState(false);
  let t1;
  if ($[0] !== content) {
    t1 = !!content && content.trim().length > 0;
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasBody = t1;
  if (!hasBody && !title && !image) {
    let t2;
    if ($[2] !== children) {
      t2 = <>{children}</>;
      $[2] = children;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t2 = `relative inline-block ${className ?? ""}`;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShow(true);
    t4 = () => setShow(false);
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== content || $[7] !== hasBody || $[8] !== image || $[9] !== show || $[10] !== title) {
    t5 = show && <span className="absolute z-50 bottom-full left-0 mb-2 w-64 p-2.5 rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-card)] shadow-xl pointer-events-none text-left normal-case font-normal"><span className="flex gap-2.5">{image && <img src={imageUrl(image)} alt="" crossOrigin="anonymous" className="w-11 h-11 object-contain flex-none rounded" />}<span className="block min-w-0">{title && <span className="block text-xs font-semibold text-[var(--text-primary)] mb-1">{title}</span>}{hasBody && <span className="block text-[11px] text-[var(--text-secondary)] leading-relaxed"><RichDescriptionSimple text={content as string} /></span>}</span></span></span>;
    $[6] = content;
    $[7] = hasBody;
    $[8] = image;
    $[9] = show;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== t2 || $[14] !== t5) {
    t6 = <span className={t2} onMouseEnter={t3} onMouseLeave={t4}>{children}{t5}</span>;
    $[12] = children;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}